import { PatientIdentifiers } from './Profile.model';
import { ProfileAdapter } from './Profile.reducer';

export const ProfileSelector = {
  ...ProfileAdapter.getSelectors((state: any) => state.profiles),
  selectIdentifiersById: (
    state: any,
    userId: string,
  ): PatientIdentifiers | undefined => state.profiles.identifiers?.[userId],
};
